import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import { SiteProvider } from './context/SiteContext';
import { AdminThemeProvider } from './contexts/AdminTheme';
import ModernOnboardingForm from './components/ModernOnboardingForm';
import SiteEditor from './components/SiteEditor';
import Dashboard from './components/Dashboard';
import Login from './components/Login';
import Register from './components/Register';
import AdminDashboard from './components/AdminDashboard';
import AdminSettings from './components/AdminSettings';
import AdminPlanManager from './components/AdminPlanManager';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <SiteProvider>
        <Router>
          <div className="App flex flex-col">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/" element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              } />
              <Route path="/create" element={
                <ProtectedRoute>
                  <ModernOnboardingForm />
                </ProtectedRoute>
              } />
              <Route path="/editor/:siteId" element={
                <ProtectedRoute>
                  <SiteEditor />
                </ProtectedRoute>
              } />
              <Route path="/admin" element={
                <ProtectedRoute>
                  <AdminThemeProvider>
                    <AdminDashboard />
                  </AdminThemeProvider>
                </ProtectedRoute>
              } />
              <Route path="/admin/settings" element={
                <ProtectedRoute>
                  <AdminThemeProvider>
                    <AdminSettings />
                  </AdminThemeProvider>
                </ProtectedRoute>
              } />
              <Route path="/admin/plans" element={
                <ProtectedRoute>
                  <AdminThemeProvider>
                    <AdminPlanManager />
                  </AdminThemeProvider>
                </ProtectedRoute>
              } />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </Router>
      </SiteProvider>
    </AuthProvider>
  );
}

export default App;